
import {
  computed, defineComponent,
} from 'vue';

export default defineComponent({
  name: 'SelecionarTipoDocumentoFiscal',
  components: {
  },
  props: {
    valor: {
      type: Number || undefined,
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioButton: {
      type: Boolean,
      default: false,
    },
    limparSelecao: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:valor', 'change', 'blur'],
  setup(props, { emit }) {
    function obterValor():any {
      return (props.valor === 0 ? undefined : props.valor);
    }

    const computedValor = computed({
      get: () => obterValor(),
      set: (valor: number) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor:number) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValorMarcado(valor:number) {
      emit('change', valor);
    }

    function blur() {
      emit('blur');
    }

    return {
      props,
      computedValor,
      defineValorSelecionado,
      defineValorMarcado,
      blur,
    };
  },
});
